import { ShopifyGqlIdType } from "@intelligems/ig-types";

export const toGqlId = (id: string, type: ShopifyGqlIdType): string => {
  if (id.includes("gid")) {
    return id;
  }
  return `gid://shopify/${type}/${id}`;
};

export const fromGqlId = (gqlId: string): string => {
  const index = gqlId.lastIndexOf("/");
  return index > -1 ? gqlId.substring(index + 1) : gqlId;
};
